(function MoveGlobalRecipients(Adzuki)
{
	"use strict";

	var MoveGlobalRecipients = {};

	// public properties
	MoveGlobalRecipients.container = null;
	MoveGlobalRecipients.recipients = null;

	MoveGlobalRecipients.setProperties = function setProperties() {
		this.container       = $('.move-global-recipients');
		this.formName        = this.container.attr('data-form');
		this.selectionColumn = this.container.find('.selection-column');
		this.addedColumn     = this.container.find('.added-column');
		this.listGroup       = this.addedColumn.find('.list-group');
	};

	$(document).ready(function documentReady()
	{

		MoveGlobalRecipients.setProperties();

		if (MoveGlobalRecipients.container.length > 0) {

			MoveGlobalRecipients.container.find('.loading').hide();
			MoveGlobalRecipients.container.find('.loaded').show();

			MoveGlobalRecipients.container
				.find('.controls .add-selected')
				.on(
					'click',
					function addSelected(e) {
						var serial = MoveGlobalRecipients.selectionColumn.find('.recipient input').serializeArray();
						e.preventDefault();

						Adzuki.Ajax
							.post(
								Adzuki.base_uri + '/Clients/getClientsByResource',
								{
									form_data: serial,
								}
							)
							.then(
								function success(response) {
									if (response.status === 'success') {
										console.log(response);
										addCacheRecipients(response.data);
									}

									clearSelected();
									MoveGlobalRecipients.listGroup.removeClass('empty');
								}
							)
						;
					}
				)
			;

			MoveGlobalRecipients.container
				.find('.added-column')
				.on(
					'click',
					'.remove-item',
					function removeRecipient(e) {
						var listItem = $(this).parent('.list-group-item');
						var clientId = listItem.find('input').val();

						e.preventDefault();

						Adzuki.Ajax
							.post(
								Adzuki.base_uri + '/Clients/removeClientCache/'+clientId
							)
							.then(
								function success(response) {
									if (response.status === 'success') {
										listItem.remove();
									}
								}
							)
						;
					}
				)
			;

			MoveGlobalRecipients.container
				.find('.controls .remove-all')
				.on(
					'click',
					function removeAll(e) {
						e.preventDefault();

						Adzuki.CustomConfirm({
							body   : 'Are you sure you wish to remove all?',
							confirm: function clear() {
								Adzuki.Ajax.post(
									Adzuki.base_uri + '/Clients/clearClientCache'
								)
								.then(function success(response) {
									if (response.status === 'success') {
										console.log(response);
									}
								});

								MoveGlobalRecipients.listGroup.empty();
								MoveGlobalRecipients.listGroup.addClass('empty');
							}
						});
					}
				)
			;
		}

	});

	function getAddedCacheRecipients(clientIds) {
		console.log(clientIds);
		Adzuki.Ajax
			.post(
				Adzuki.base_uri + '/Clients/getClientCache/',
				{
					form_data: clientIds,
					form_name: MoveGlobalRecipients.formName
				}
			)
			.then(
				function success(response) {
					appendRecipients(response);
				}
			)
		;
	}

	function addCacheRecipients(recipients) {
		Adzuki.Ajax
			.post(
				Adzuki.base_uri + '/Clients/setClientCache/',
				{
					form_data: recipients,
				}
			)
			.then(
				function success(response) {
					if (response.status === 'success') {
						if (response.new.length > 0) {
							getAddedCacheRecipients(response.new);
						}

						if (response.duplicated.length > 0) {
							Adzuki.StatusMessage(null, 'The requested action contained duplicate entries.', 'Duplicate entries removed.');
						}
					}
				}
			)
		;
	}

	function appendRecipients(response) {
		if (response) {
			$(response).hide().prependTo(MoveGlobalRecipients.listGroup).slideDown();
			MoveGlobalRecipients.listGroup.removeClass('empty');
		}
	}


	function clearSelected() {
		var selected = MoveGlobalRecipients.selectionColumn.find('.recipient').not('.template');

		selected.slideUp(
			'normal',
			function finishSlide() {
				$(this).find('.remove').click();
				MoveGlobalRecipients.selectionColumn.find('.selected-recipients').addClass('hidden');
			}
		);
	}

	Adzuki.MoveGlobalRecipients = MoveGlobalRecipients;

// close function scope and immediately execute function, passing window.Adzuki object as the argument
}(window.Adzuki || {}));
